/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { ICustomDate } from "@Internal/Contracts";
import BaseModel from "../Model";

import BaseCustomer from "../Customer";
import BasePlan from "../Plan";
import BasePrice from "../Price";
import BasePriceTarget from "../PriceTarget";
import BaseProduct from "../Product";
import BaseTier from "../Tier";

export default
interface BaseSubscriptionCoupon<
    P = BasePlan<BaseProduct>,
    T = BasePrice<BasePriceTarget, BaseProduct, BaseTier, BasePlan>,
    K = BaseCustomer
> extends BaseModel {
    Name: string;
    Active?: boolean;
    GeneralConditions?: string;
    FixedAmount?: number;
    Percentage?: number;
    /* Duration in months.  */
    Duration?: number;
    From?: ICustomDate;
    To?: ICustomDate;
    MaxUses?: number;
    Uses?: number;
    Code?: string;
    FirstSubscriptionOnly?: boolean;
    /* Set when the coupon was manually stopped: full timestamp of the stop (CustomDateTime keeps
       the time, unlike CustomDate) and the Console user who did it. Both stay undefined for
       coupons never stopped by hand. */
    StoppedAt?: ICustomDate;
    StoppedBy?: string;
    Plans: P[];
    GlobalPrices: T[];
    Customers: K[];
}
